import React from 'react';
import {connect} from 'react-redux';
import {
    favouriteAdd, favouriteMove, favouriteRemove, favouriteSelect,
    favouriteSetOfferId
} from '../../../common/menu/favourite/actions';
import Products from '../../home/Products';
import ArrLeftButton from '../../components/buttons/ArrLeftButton';
import ArrRightButton from '../../components/buttons/ArrRightButton';

class Favourite extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        favouriteSetOfferId: React.PropTypes.func,
        favouriteAdd: React.PropTypes.func,
        favouriteMove: React.PropTypes.func,
        favouriteRemove: React.PropTypes.func,
        favouriteSelect: React.PropTypes.func,
        favouriteItems: React.PropTypes.object,
        itemNames: React.PropTypes.object,
        itemColors: React.PropTypes.object,
        frequentlyItemsOffer: React.PropTypes.object,
        offerId: React.PropTypes.number,
        selected: React.PropTypes.number
    };

    componentWillMount() {
        const {offerId, favouriteSetOfferId} = this.props;
        favouriteSetOfferId(offerId);
    }

    componentWillUnmount() {
        const {favouriteSelect, favouriteSetOfferId} = this.props;
        favouriteSelect(null);
        favouriteSetOfferId(null);
    }

    render() {
        const {
            favouriteItems, offerId, selected, favouriteRemove, favouriteSelect, favouriteMove, itemColors,
            favouriteAdd, itemNames, frequentlyItemsOffer, msg
        } = this.props;

        const favouriteCount = !!favouriteItems && favouriteItems.has(offerId) ? favouriteItems.get(offerId).size : 0;

        return (
            <div className="pageFavourite menu-favourite">
                <div className="pageFavourite-header">
                    <div className="menuPage-title">
                      <span>{msg.favourites.title}</span>
                    </div>
                </div>

                <div className="pageFavourite-products">
                    <Products maxButtons={25}
                              selectProduct={favouriteAdd}
                              sectionId="favouriteProductsGrid"/>
                </div>

                <div className="pageFavourite-shortcuts">
                    <div className="favouriteList">
                        {!!favouriteItems && favouriteItems.has(offerId)
                        && favouriteItems.get(offerId).map((id, index) =>
                            <div key={`favourite-item-${index}`} className="favouriteList-box">
                                <div className={`boxBtn color-white ${selected === index ? 'is-selected' : ''}`}>
                                    <div className="boxBtn-inner"
                                         style={{
                                             backgroundColor: itemColors.getIn([id, 'backgroundColor']),
                                             color: itemColors.getIn([id, 'textColor'])
                                         }}
                                         onClick={() => favouriteSelect(index)}>
                                        <span>{itemNames.get(id)}</span>
                                    </div>
                                </div>
                            </div>
                        )}
                        {favouriteCount < 10 &&
                            <div className="favouriteList-box">
                                <div className={`boxBtn ${selected === null ? 'is-selected' : ''}`}>
                                    <div className="boxBtn-inner" onClick={() => favouriteSelect(null)}>
                              <span>
                                 {msg.favourites.addShortcut}
                              </span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="pageFavourite-used">
                    <div className="pageFavourite-used-title">
                        <span>{msg.favourites.frequentlyUsed}:</span>
                    </div>
                    <div className="pageFavourite-used-products">
                        {/* max 9 */}
                        {!!frequentlyItemsOffer && frequentlyItemsOffer.sortBy((val, key) => val).reverse().slice(0, 9).map((val, key) =>
                            <div key={`freq-${key}`} className="pageFavourite-used-product">
                                <div className="boxBtn color-white">
                                    <div className="boxBtn-inner"
                                         style={{
                                             backgroundColor: itemColors.getIn([key, 'backgroundColor']),
                                             color: itemColors.getIn([key, 'textColor'])
                                         }}
                                         onClick={() => favouriteAdd(key)}>
                                        <span>{itemNames.get(key)}</span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="pageFavourite-controls">
                  <div className="pageFavourite-controls-key">
                    <div className={`boxBtn color-white ${selected === null || selected === 0 ? 'disabled' : ''}`} onClick={() => favouriteMove(-1)}>
                        <ArrLeftButton/>
                    </div>
                  </div>
                  <div className="pageFavourite-controls-key">
                    <div className={`boxBtn color-white ${selected === null || selected === (favouriteCount - 1) ? 'disabled' : ''}`} onClick={() => favouriteMove(+1)}>
                        <ArrRightButton/>
                    </div>
                  </div>
                  <div className="pageFavourite-controls-key">
                  </div>
                  <div className="pageFavourite-controls-key">
                    <div className={`boxBtn text-l color-red ${selected === null ? 'disabled' : ''}`}>
                        <div className={`boxBtn-inner`}
                             onClick={() => favouriteRemove()}>
                            <span>{msg.global.delete}</span>
                        </div>
                    </div>
                  </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    selected: state.favourite.get('selected'),
    itemNames: state.categories.get('itemNames'),
    itemColors: state.categories.get('itemColors'),
    frequentlyItemsOffer: state.categories.get('frequentlyItemsOffer'),
    favouriteItems: state.favourite.get('favouriteItems'),
    offerId: state.categories.get('offerId')
}), {favouriteAdd, favouriteMove, favouriteRemove, favouriteSelect, favouriteSetOfferId})(Favourite);



// WEBPACK FOOTER //
// ./src/browser/menu/favourite/Favourite.js